import axios from "axios";
import { Distributor } from "@/models/distributor.model";

class DistributorService {
  /**
   * Pobiera listę wszystkich dystrybutorów
   */
  async getDistributors(): Promise<Distributor[]> {
    const response = await axios.get<Distributor[]>("/distributor");
    return response.data;
  }

  /**
   * Pobiera szczegóły dystrybutora po ID
   * @param id ID dystrybutora
   */
  async getDistributorById(id: string): Promise<Distributor> {
    const response = await axios.get<Distributor>(`/distributor/${id}`);
    return response.data;
  }

  /**
   * Tworzy nowego dystrybutora
   * @param distributor Dane nowego dystrybutora
   */
  async createDistributor(distributor: Distributor): Promise<Distributor> {
    const response = await axios.post<Distributor>("/distributor", distributor);
    return response.data;
  }

  /**
   * Aktualizuje dane dystrybutora
   * @param id ID dystrybutora
   * @param distributor Dane do aktualizacji
   */
  async updateDistributor(id: string, distributor: Partial<Distributor>): Promise<Distributor> {
    const response = await axios.put<Distributor>(`/distributor/${id}`, distributor);
    return response.data;
  }

  /**
   * Usuwa dystrybutora po ID
   * @param id ID dystrybutora
   */
  async deleteDistributor(id: string): Promise<void> {
    await axios.delete(`/distributor/${id}`);
  }
}

// Eksportowanie instancji serwisu
export default new DistributorService();
